export default "__VITE_ASSET__Bdk3N9ZA__"